// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SystemMessages_wrapper__3-ycd","scrollWrapper":"SystemMessages_scrollWrapper__2P159","newMessagesWrapper":"SystemMessages_newMessagesWrapper__2ZyIK"};